import { dateValue, isBusinessDay } from "../commercial/utils/calendar.mjs";
export function previousBusinessDay(value) {
  if (!dateValue(value)) throw new Error("Date invalide");
  const date = new Date(`${value}T12:00:00Z`);
  do {
    date.setUTCDate(date.getUTCDate() - 1);
  } while (!isBusinessDay(date.toISOString().slice(0, 10)));
  return date.toISOString().slice(0, 10);
}
